import { QueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { WhatsappOpeningMessageEdit } from "modules/campaigns/components/Sections/channels/whatsappOpeningMessages/WhatsappOpeningMessageEdit"
import { whatsappOpeningMessageQuery } from "modules/campaigns/lib/templates/openingMessages/whatsappOpeningMessageQuery"
import { Crumb } from "modules/shared/lib/breadcrumbs"

function getOpeningMessage(id: string, queryClient: QueryClient) {
  const openingMessage = queryClient.getQueryData(whatsappOpeningMessageQuery({ id }).queryKey)
  if (openingMessage) return openingMessage.identifier

  return queryClient
    .fetchQuery(whatsappOpeningMessageQuery({ id }))
    .then((openingMessage) => openingMessage.identifier)
}

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/openings/$id")({
  component: WhatsappOpeningMessageEdit,
  loader: ({ route: { fullPath }, params, context }) => {
    return new Crumb({
      fullPath,
      title: getOpeningMessage(params.id, context.queryClient),
    })
  },
})
